import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const initialState = {
  name: '',
  shouldBeUpdated: true,
};

export const loadProperty = createAsyncThunk(
  'property/loadProperty',
  async (_, { dispatch, extra: api }) => {
    try {
      const result = await api.getMyProperty();
      return { name: (result && result.name) || '' };
    } catch (error) {
      if (error.isAxiosError) {
        dispatch({ type: 'account/logoff' });
      }
      throw error;
    }
  }
);

const propertySlice = createSlice({
  name: 'property',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadProperty.fulfilled, (state, action) => {
        return { ...state, name: action.payload.name, shouldBeUpdated: false };
      })
      .addCase(loadProperty.rejected, (state) => {
        return { ...state, shouldBeUpdated: false };
      });
  }
});

export default propertySlice.reducer;
